module.exports = __webpack_public_path__ + "static/img/ewm2.501d1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ewm2.png
// module id = /9Jd
// module chunks = 1